import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: 'rgba(6, 14, 26, 0.98)',
      borderTop: '1px solid rgba(168,207,224,0.08)',
      paddingTop: '48px',
    }}>
      <div className="container">

        {/* Top: logo + tagline + nav columns */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '40px',
          paddingBottom: '40px',
          borderBottom: '1px solid rgba(168,207,224,0.08)',
        }} className="footer-grid">

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <svg width="30" height="30" viewBox="0 0 34 34" fill="none" aria-hidden="true">
                <circle cx="17" cy="17" r="16" stroke="rgba(201,168,76,0.4)" strokeWidth="1.2" />
                <path d="M17 6 L19 17 L17 28 L15 17 Z" fill="#c9a84c" />
                <path d="M6 17 L17 15 L28 17 L17 19 Z" fill="rgba(168,207,224,0.4)" />
                <circle cx="17" cy="17" r="2" fill="#c9a84c" />
              </svg>
              <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: '1rem', color: '#fff' }}>
                Social North Hub
              </span>
            </div>
            <p style={{ fontSize: '0.85rem', color: 'rgba(168,207,224,0.5)', maxWidth: '280px', lineHeight: 1.7, marginBottom: '14px' }}>
              Browser-based navigation activities for Canadian adults. Session points only — no money ever involved.
            </p>
            <div style={{
              display: 'inline-block', padding: '5px 14px',
              borderRadius: '999px', border: '1px solid rgba(201,168,76,0.25)',
              fontSize: '0.7rem', color: 'rgba(201,168,76,0.7)',
              fontFamily: 'Syne, sans-serif', fontWeight: 700, letterSpacing: '0.1em',
            }}>
              18+ · CANADA · ENTERTAINMENT ONLY
            </div>
          </div>

          {/* Explore */}
          <div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.75rem', color: 'rgba(168,207,224,0.4)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '14px' }}>
              Explore
            </div>
            {[
              { to: '/activities', label: 'All Activities' },
              { to: '/activities/compass-read', label: 'Compass Read' },
              { to: '/activities/route-builder', label: 'Route Builder' },
              { to: '/activities/altitude-gauge', label: 'Altitude Gauge' },
              { to: '/how-it-works', label: 'How It Works' },
            ].map(({ to, label }) => (
              <Link key={to} to={to} style={{
                display: 'block', fontSize: '0.88rem',
                color: 'rgba(168,207,224,0.6)', marginBottom: '9px',
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.target.style.color = 'rgba(168,207,224,1)'}
              onMouseLeave={e => e.target.style.color = 'rgba(168,207,224,0.6)'}
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Info */}
          <div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.75rem', color: 'rgba(168,207,224,0.4)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '14px' }}>
              Information
            </div>
            {[
              { to: '/about-hub', label: 'About the Hub' },
              { to: '/mindful-play', label: 'Mindful Play' },
              { to: '/reach-us', label: 'Contact Us' },
              { to: '/hub-terms', label: 'Terms of Use' },
              { to: '/privacy', label: 'Privacy Policy' },
              { to: '/cookie-notice', label: 'Cookie Notice' },
            ].map(({ to, label }) => (
              <Link key={to} to={to} style={{
                display: 'block', fontSize: '0.88rem',
                color: 'rgba(168,207,224,0.6)', marginBottom: '9px',
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.target.style.color = 'rgba(168,207,224,1)'}
              onMouseLeave={e => e.target.style.color = 'rgba(168,207,224,0.6)'}
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Support resources */}
          <div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.75rem', color: 'rgba(168,207,224,0.4)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '14px' }}>
              Support Resources
            </div>
            <p style={{ fontSize: '0.8rem', color: 'rgba(168,207,224,0.5)', marginBottom: '12px', lineHeight: 1.6 }}>
              If you or someone you know needs support with problematic play habits:
            </p>
            {[
              { label: 'ConnexOntario', sub: '1-866-531-2600 · 24/7', href: 'https://www.connexontario.ca' },
              { label: 'Gambling Support BC', sub: '1-888-795-6111', href: 'https://www.bcresponsiblegambling.ca' },
              { label: 'Responsible Gambling Council', sub: 'responsiblegambling.org', href: 'https://www.responsiblegambling.org' },
            ].map(({ label, sub, href }) => (
              <a key={href} href={href} target="_blank" rel="noopener noreferrer" style={{
                display: 'block', marginBottom: '10px', textDecoration: 'none',
              }}>
                <div style={{ fontSize: '0.85rem', color: 'rgba(201,168,76,0.8)', fontWeight: 500 }}>{label}</div>
                <div style={{ fontSize: '0.75rem', color: 'rgba(168,207,224,0.4)' }}>{sub}</div>
              </a>
            ))}
          </div>

        </div>

        {/* Legal disclaimer block — unique wording, once only */}
        <div style={{
          padding: '24px 0',
          borderBottom: '1px solid rgba(168,207,224,0.06)',
        }}>
          <div style={{
            background: 'rgba(168,207,224,0.03)',
            border: '1px solid rgba(168,207,224,0.08)',
            borderRadius: '12px',
            padding: '18px 22px',
          }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.72rem', fontWeight: 700, color: 'rgba(201,168,76,0.6)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '8px' }}>
              Platform Notice
            </div>
            <p style={{ fontSize: '0.78rem', color: 'rgba(168,207,224,0.45)', lineHeight: 1.8, margin: 0 }}>
              Social North Hub is a free browser-based entertainment platform operated by <strong style={{ color: 'rgba(168,207,224,0.65)' }}>Social North Hub</strong> for adults aged 18 and over residing in Canada. All activities on this platform use session points only. Session points are not currency, have no monetary value, and cannot be purchased, transferred, redeemed, or exchanged for anything of real-world value. This platform does not accept deposits, does not process withdrawals, and does not award cash prizes or prizes of any monetary nature. Participation is free and voluntary. This is not a real-money service of any kind.
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: '12px',
          justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 0',
          fontSize: '0.78rem', color: 'rgba(168,207,224,0.35)',
        }}>
          <span>© {year} Social North Hub. All rights reserved.</span>
          <span>support@socialnorthhub.com</span>
          <div style={{ display: 'flex', gap: '16px' }}>
            <Link to="/hub-terms" style={{ color: 'rgba(168,207,224,0.35)', textDecoration: 'none' }}>Terms</Link>
            <Link to="/privacy" style={{ color: 'rgba(168,207,224,0.35)', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/cookie-notice" style={{ color: 'rgba(168,207,224,0.35)', textDecoration: 'none' }}>Cookies</Link>
          </div>
        </div>

      </div>

      <style>{`
        @media (min-width: 768px) {
          .footer-grid { grid-template-columns: 1.4fr 1fr 1fr 1.2fr !important; }
        }
      `}</style>
    </footer>
  );
}
